import { intersection, isPlainObject } from 'lodash';

import { IDynamicContextBindingConfig } from '../types/dynamic-context-binding-config.interface';

const contextConfigKeys: (keyof IDynamicContextBindingConfig)[] = ['path', 'type'];

/**
 * Determines if the given argument resembles an IDynamicContextBindingConfig
 */
export const isDynamicContextBindingConfig = (value: unknown): boolean => {
  if (!isPlainObject(value)) {
    return false;
  }

  return intersection(contextConfigKeys, Object.keys(value as object)).length === contextConfigKeys.length;
};
